
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/RelativeTask/RelativeTask.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./RelativeTask.html');
        
        var script = require('./RelativeTask.ts').default;
        module.exports = require('./RelativeTask.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    